module.exports = __webpack_public_path__ + "media/still with you.819f138d.mp3";